import {IId} from '@/interfaces';
import {ABTEST_STATUS} from '@/api/interfaces';
import {IRegisteredHost} from '@/queries/hosts/interfaces';

export enum ABTEST_TYPES {
    heroImage = 1,
    feed1 = 2,
    feed2 = 3
}

export enum ABTEST_IMG_POSITION {
    top = 1,
    bottom = 2
}

export interface IABTestArticle {
    remote_id: IId;
    remote_url: string;
}

export interface IABTestConfig {
    type: ABTEST_TYPES;
    configuration: {
        enabled?: boolean;
        image?: FileList | string;
        position?: number | string | null | ABTEST_IMG_POSITION;
        height?: number | string | null;
    };
}

export interface IABTest {
    id: IId;
    name: string;
    host_id: IId;
    articles: IABTestArticle[];
    status: ABTEST_STATUS;
    start_date: string | null;
    end_date: string | null;
    configurations: IABTestConfig[];
    _embedded?: {
        ['about:host']?: IRegisteredHost[];
    };
}

export interface IABTestsGrid {
    data?: IABTest[];
    total?: number;
}

export interface IABTestValues
    extends Omit<IABTest, 'id' | 'articles' | 'status' | 'start_date' | 'end_date' | '_embedded'> {
    articles: IABTestArticle[] | undefined;
    articlesForShow: string[] | undefined;
}
